import fileSys from "../../fileoprators/fileSystem";
import SettingsOprator from "../settingsoprator";
import { DATASHOW } from "../consts";
const DEFAULTSET = DATASHOW;
class DataShow extends SettingsOprator {
  constructor() {
    super(fileSys.getTopographyCfgPath("dataShowSettings.json"), DEFAULTSET);
  }
  getDataShowSettings() {
    return this.getSettings();
  }
  saveDataShowSettings(settings) {
    this.saveSettings(settings);
  }
}
export default DataShow;



// WEBPACK FOOTER //
// ./src/settings/topography/dataShow.js